import { actionTypes } from './actions';
import initialState from './initialState';

export default function messagesReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('data', null).set('error', null);
    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('data', action.payload);
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    case actionTypes.FEEDBACK_SENT:
      return state.set('data', clearFeedbackFlag(state.get('data'), action.payload));
    default:
      return state;
  }
}

function clearFeedbackFlag(data, id) {
  return data.map((message) => {
    if (+message.cardId !== +id) {
      return message;
    }

    const history = message.history.map((item) => {
      if (item.needsFeedback) {
        item.needsFeedback = false;
      }

      return item;
    });

    return Object.assign({}, message, { history });
  });
}
